import script from "./pageTeamMembers.vue?vue&type=script&setup=true&lang=js"
export * from "./pageTeamMembers.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__